module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin9-c22ebaf5a419fd420cd1f6b276dd56c4.jpg";